import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Fab from '@mui/material/Fab';
import CheckIcon from '@mui/icons-material/Check';

export default function CircularIntegration({ Icon, successIcon = CheckIcon, status = "pending" }) {

    const isLoading = status === "Started";
    const isSuccess = status === "Success" || status === "Completed";

    const getColor = () => {
        switch(status) {
            case "pending": return "grey";
            case "Completed": return green[500];
            case "Error": return "red";
            default: return "grey";
        }
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', m: 1, position: 'relative' }}>
            <Fab
                sx={{
                    bgcolor: isSuccess ? green[500] : undefined,
                    '&:hover': { bgcolor: isSuccess ? green[700] : undefined },
                }}
            >
                {React.createElement(Icon, { sx: { fontSize: 40 } })}
            </Fab>

            {isLoading && (
                <CircularProgress
                    size={68}
                    sx={{
                        color: getColor(),
                        position: 'absolute',
                        top: -6,
                        left: -6,
                        zIndex: 1,
                    }}
                />
            )}
        </Box>
    );
}

CircularIntegration.propTypes = {
    Icon: PropTypes.elementType.isRequired,
    successIcon: PropTypes.elementType,
    status: PropTypes.oneOf(['pending', 'Started', 'Success', 'Completed', 'Error']),
};
